module.exports = __webpack_public_path__ + "static/logo.bccfb14c.svg";